/* Pied de page en accordeons sous 990px — releve antler.co.uk du 14/08.
   Au-dessus de 990px on retire tout, le footer redevient la grille Dawn. */
(function () {
  'use strict';

  function blocs() {
    // uniquement les colonnes de liens : un titre + du contenu derriere
    return Array.prototype.filter.call(
      document.querySelectorAll('.footer-block.grid__item'),
      function (b) { return b.querySelector('.footer-block__heading'); }
    );
  }

  function basculer(e) {
    var b = e.currentTarget.closest('.footer-block');
    if (b) b.classList.toggle('is-open');
  }

  function appliquer() {
    var mobile = window.innerWidth < 990;
    blocs().forEach(function (b) {
      var h = b.querySelector('.footer-block__heading');
      if (mobile && !b.classList.contains('js-acc')) {
        b.classList.add('js-acc');
        h.setAttribute('role', 'button');
        h.setAttribute('tabindex', '0');
        h.addEventListener('click', basculer);
        h.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); basculer(e); }
        });
      } else if (!mobile && b.classList.contains('js-acc')) {
        b.classList.remove('js-acc', 'is-open');
        h.removeAttribute('role');
        h.removeAttribute('tabindex');
      }
    });
  }

  var minuteur;
  window.addEventListener('resize', function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(appliquer, 150);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appliquer);
  } else {
    appliquer();
  }
})();


/* Fiche produit : la variante Taille — rangee "Other Sizes" qui deplie une
   liste TEXTE des tailles (v3, demande Nathan : plus de modal avec images).
   La rangee et la liste vivent HORS de la zone re-rendue par Dawn. */
(function () {
  function pill() { return document.querySelector('.product-form__input--pill'); }
  function radios() { return pill() ? [].slice.call(pill().querySelectorAll('input[type="radio"]')) : []; }
  function courante() {
    var rs = radios();
    for (var i = 0; i < rs.length; i++) if (rs[i].checked) return rs[i].value;
    return rs.length ? rs[0].value : '';
  }

  function construire() {
    var f = pill();
    if (!f || radios().length < 2) return;
    if (document.querySelector('.carry-sizes-row')) return;
    var orphelines = document.querySelectorAll('.carry-sizes-list');
    for (var oi = 0; oi < orphelines.length; oi++) orphelines[oi].parentNode.removeChild(orphelines[oi]);

    var hote = f.closest('variant-selects') || f;
    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'carry-sizes-row';
    row.setAttribute('aria-expanded', 'false');
    row.innerHTML = '<span>Other Sizes</span><span class="carry-sizes-row__val"><span class="carry-sizes-row__txt"></span> <svg viewBox="0 0 10 16" width="9" height="14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m2 2 6 6-6 6"/></svg></span>';
    hote.parentNode.insertBefore(row, hote.nextSibling);
    row.querySelector('.carry-sizes-row__txt').textContent = courante();

    var liste = document.createElement('div');
    liste.className = 'carry-sizes-list';
    liste.hidden = true;
    row.parentNode.insertBefore(liste, row.nextSibling);

    function remplir() {
      var html = '';
      radios().forEach(function (r) {
        html += '<button type="button" class="carry-sizes-list__item' + (r.checked ? ' is-current' : '') + '" data-value="' + r.value.replace(/"/g, '&quot;') + '">' + r.value + '</button>';
      });
      liste.innerHTML = html;
    }
    function fermer() {
      liste.hidden = true;
      row.classList.remove('is-open');
      row.setAttribute('aria-expanded', 'false');
    }
    row.addEventListener('click', function () {
      if (liste.hidden) {
        remplir();
        liste.hidden = false;
        row.classList.add('is-open');
        row.setAttribute('aria-expanded', 'true');
      } else {
        fermer();
      }
    });
    liste.addEventListener('click', function (e) {
      var it = e.target.closest('.carry-sizes-list__item');
      if (!it) return;
      var val = it.getAttribute('data-value');
      var rs = radios();
      for (var i = 0; i < rs.length; i++) {
        if (rs[i].value === val && !rs[i].checked) {
          rs[i].checked = true;
          rs[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
      synchroniser(val);
      fermer();
    });
    function synchroniser(val) {
      var txt = row.querySelector('.carry-sizes-row__txt');
      if (txt) txt.textContent = val;
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.product-form__input--pill input[type="radio"]')) {
        synchroniser(e.target.value);
      }
    });
  }

  function veiller() {
    construire();
    var zone = document.querySelector('.product__info-container') || document.body;
    new MutationObserver(function () {
      if (!document.querySelector('.carry-sizes-row')) construire();
    }).observe(zone, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') veiller();
  else document.addEventListener('DOMContentLoaded', veiller);
})();

/* Fiche produit : la description devient un accordeon OUVERT par defaut,
   tronque a ~6 lignes avec "Show more..." (systeme Antler). */
(function () {
  function initDesc() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.closest('.carry-acc')) return;
    var det = document.createElement('details');
    det.className = 'carry-acc';
    var sum = document.createElement('summary');
    sum.className = 'carry-acc__sum';
    sum.innerHTML = '<span>Description</span>';
    var body = document.createElement('div');
    body.className = 'carry-acc__body';
    desc.parentNode.insertBefore(det, desc);
    det.appendChild(sum);
    det.appendChild(body);
    body.appendChild(desc);
    if (desc.scrollHeight > 170) {
      desc.classList.add('is-clamped');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'carry-showmore';
      more.textContent = 'Show more...';
      body.appendChild(more);
      more.addEventListener('click', function () {
        var c = desc.classList.toggle('is-clamped');
        more.textContent = c ? 'Show more...' : 'Show less';
      });
    }
  }
  if (document.readyState !== 'loading') initDesc();
  else document.addEventListener('DOMContentLoaded', initDesc);
})();


/* La description du theme est DEJA un accordeon : on l'ouvre par defaut,
   on tronque son contenu a ~6 lignes et on ajoute "Show more..." (Antler). */
(function () {
  function initDescAcc() {
    var accs = document.querySelectorAll('.product__accordion');
    for (var i = 0; i < accs.length; i++) {
      var t = accs[i].querySelector('.accordion__title');
      if (!t || t.textContent.trim() !== 'Description') continue;
      var det = accs[i].querySelector('details') || accs[i];
      if (det.dataset.carryDesc) return;
      det.dataset.carryDesc = '1';
      var content = det.querySelector('.accordion__content');
      if (!content) return;
      if (content.scrollHeight > 190) {
        content.classList.add('is-clamped');
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'carry-showmore';
        more.textContent = 'Show more...';
        content.parentNode.appendChild(more);
        more.addEventListener('click', function () {
          var c = content.classList.toggle('is-clamped');
          more.textContent = c ? 'Show more...' : 'Show less';
        });
      }
      return;
    }
  }
  if (document.readyState !== 'loading') initDescAcc();
  else document.addEventListener('DOMContentLoaded', initDescAcc);
})();


/* « You May Also Like » : titre a gauche + fleches ‹ › qui font defiler
   la rangee (releve Antler). La grille Dawn devient une rangee scrollable
   en CSS ; ici on ajoute les fleches et le pas de defilement. */
(function () {
  function initRel() {
    var sec = document.querySelector('.related-products');
    if (!sec || sec.querySelector('.carry-rel-nav')) return;
    var grid = sec.querySelector('ul.grid, .grid');
    var head = sec.querySelector('h2, .related-products__heading');
    if (!grid || !head) return;
    var nav = document.createElement('div');
    nav.className = 'carry-rel-nav';
    nav.innerHTML = '<button type="button" aria-label="Previous" data-dir="-1">&#8249;</button>'
      + '<button type="button" aria-label="Next" data-dir="1">&#8250;</button>';
    head.parentNode.insertBefore(nav, head.nextSibling);
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var pas = Math.round(grid.clientWidth * 0.75) * parseInt(b.dataset.dir, 10);
      grid.scrollBy({ left: pas, behavior: 'smooth' });
    });
  }
  if (document.readyState !== 'loading') initRel();
  else document.addEventListener('DOMContentLoaded', initRel);
})();


/* ---- carrousel des cartes produit (fleches .havinbag-card-arrow) ----
   Les boutons existaient sans handler : le clic traversait vers la fiche.
   Delegation en phase capture : on navigue dans data-images et on bloque
   la navigation du lien etire. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.havinbag-card-arrow');
  if (!btn) return;
  if (e.__carryNavDone) return;
  e.__carryNavDone = true;
  e.preventDefault();
  e.stopPropagation();
  var nav = btn.closest('.havinbag-card-nav');
  var media = btn.closest('.media');
  if (!nav || !media) return;
  var urls = (nav.getAttribute('data-images') || '').split('|').filter(Boolean);
  if (urls.length < 2) return;
  var idx = parseInt(nav.getAttribute('data-idx') || '0', 10) || 0;
  var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
  idx = (idx + dir + urls.length) % urls.length;
  nav.setAttribute('data-idx', String(idx));
  media.querySelectorAll('img').forEach(function (img) {
    img.removeAttribute('srcset');
    img.src = urls[idx];
  });
}, true);

/* Cartes collections : achat direct compact (systeme Antler).
   Tailles CACHEES par defaut. Clic Add to bag : s'il y a plusieurs tailles,
   elles apparaissent et le clic sur une taille ajoute DIRECT au panier ;
   sinon ajout immediat. Clics par hit-test coordonnees (lien etire). */
(function () {
  function donnees(carte) {
    var sc = carte.querySelector('.carry-card-data');
    if (!sc) return null;
    try { return JSON.parse(sc.textContent); } catch (e) { return null; }
  }
  function resoudre(carte, tailleForcee, strict) {
    var d = donnees(carte);
    if (!d || !d.variants.length) return null;
    var c = carte.querySelector('.carry-sw.is-active');
    var vc = c ? c.getAttribute('data-val') : null;
    var vs = tailleForcee || null;
    if (!vs) {
      var s = carte.querySelector('.carry-size-btn.is-active');
      vs = s ? s.getAttribute('data-val') : null;
    }
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      var ok = true;
      if (d.posC > -1 && vc && v.opts[d.posC] !== vc) ok = false;
      if (d.posS > -1 && vs && v.opts[d.posS] !== vs) ok = false;
      if (ok) return v;
    }
    return strict ? null : d.variants[0];
  }
  function appliquer(carte) {
    var v = resoudre(carte);
    if (!v) return;
    if (v.img) {
      var ims = carte.querySelectorAll('.card__media img');
      for (var m = 0; m < ims.length; m++) {
        ims[m].removeAttribute('srcset');
        ims[m].src = v.img;
      }
    }
    var liens = carte.querySelectorAll('a[href*="/products/"]');
    for (var l = 0; l < liens.length; l++) {
      liens[l].href = liens[l].href.split('?')[0] + '?variant=' + v.id;
    }
    var atb = carte.querySelector('.carry-card-atb');
    if (atb && !buyDe(carte).classList.contains('is-choosing')) {
      atb.disabled = !v.av;
      atb.textContent = v.av ? 'Add to bag' : 'Sold out';
    }
  }
  function majDispo(carte) {
    var d = donnees(carte);
    if (!d) return;
    var c = carte.querySelector('.carry-sw.is-active');
    var vc = c ? c.getAttribute('data-val') : null;
    var btns = carte.querySelectorAll('.carry-size-btn');
    for (var i = 0; i < btns.length; i++) {
      var vs = btns[i].getAttribute('data-val');
      var dispo = false;
      for (var j = 0; j < d.variants.length; j++) {
        var v = d.variants[j];
        if (d.posS > -1 && v.opts[d.posS] !== vs) continue;
        if (d.posC > -1 && vc && v.opts[d.posC] !== vc) continue;
        if (v.av) { dispo = true; break; }
      }
      btns[i].classList.toggle('is-off', !dispo);
    }
  }
  function buyDe(carte) { return carte.querySelector('.carry-card-buy'); }
  function refermer(carte) {
    var buy = buyDe(carte);
    if (!buy || !buy.classList.contains('is-choosing')) return;
    buy.classList.remove('is-choosing');
    var atb = carte.querySelector('.carry-card-atb');
    if (atb) { atb.textContent = atb.disabled ? 'Sold out' : 'Add to bag'; }
  }
  function toutRefermer(sauf) {
    var ouverts = document.querySelectorAll('.carry-card-buy.is-choosing');
    for (var i = 0; i < ouverts.length; i++) {
      var carte = ouverts[i].closest('.card-wrapper');
      if (carte && carte !== sauf) refermer(carte);
    }
  }
  function ajouter(carte, tailleForcee) {
    var v = resoudre(carte, tailleForcee, !!tailleForcee);
    if (!v || !v.av) return;
    var atb = carte.querySelector('.carry-card-atb');
    if (atb) atb.classList.add('is-busy');
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && drawer.getSectionsToRender) {
      sections = drawer.getSectionsToRender().map(function (s) { return s.section || s.id; });
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }],
                             sections: sections.join(','),
                             sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (atb) atb.classList.remove('is-busy');
      refermer(carte);
      if (drawer && d && d.sections) {
        try { drawer.renderContents(d); } catch (er) {}
        setTimeout(function () { drawer.classList.remove('is-empty'); }, 80);
      }
    }).catch(function () {
      if (atb) atb.classList.remove('is-busy');
      refermer(carte);
    });
  }
  document.addEventListener('click', function (e) {
    if (typeof e.clientX !== 'number') return;
    var carte = e.target.closest && e.target.closest('.card-wrapper');
    toutRefermer(carte || null);
    if (!carte) return;
    var zones = carte.querySelectorAll('.carry-sw, .carry-size-btn, .carry-card-atb');
    for (var i = 0; i < zones.length; i++) {
      if (zones[i].offsetParent === null && !zones[i].classList.contains('carry-card-atb')) continue;
      var r = zones[i].getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue;
      if (e.clientX >= r.left - 4 && e.clientX <= r.right + 4 && e.clientY >= r.top - 4 && e.clientY <= r.bottom + 4) {
        e.preventDefault();
        e.stopPropagation();
        var el = zones[i];
        var buy = buyDe(carte);
        if (el.classList.contains('carry-card-atb')) {
          var tailles = carte.querySelectorAll('.carry-size-btn');
          if (buy.classList.contains('is-choosing')) {
            refermer(carte);
          } else if (tailles.length > 1) {
            buy.classList.add('is-choosing');
            el.textContent = 'Select a size';
            majDispo(carte);
          } else {
            ajouter(carte, null);
          }
        } else if (el.classList.contains('carry-size-btn')) {
          if (buy.classList.contains('is-choosing') && !el.classList.contains('is-off')) {
            ajouter(carte, el.getAttribute('data-val'));
          }
        } else {
          var act = carte.querySelectorAll('.carry-sw.is-active');
          for (var x = 0; x < act.length; x++) act[x].classList.remove('is-active');
          el.classList.add('is-active');
          appliquer(carte);
          majDispo(carte);
        }
        return;
      }
    }
  }, true);
})();

